import { gql } from '@apollo/client'

// DENTAL SCHOOL

const DENTAL_SCHOOL_FIELDS = gql`
  fragment DentalSchoolFields on DentalSchoolType {
    id
    slug
    isOptometry
    image
    getCoverImage
    isFeaturedExperts
    title
    description
    infoFirstColumn
    infoSecondColumn
    details {
      title
      description
      table
    }
    platform {
      id
      title
      slug
    }
  }
`

export const FIND_ALL_DENTAL_SCHOOLS = gql`
  ${DENTAL_SCHOOL_FIELDS}
  query findAllDentalSchools($query: DentalSchoolQueryInput!) {
    findAllDentalSchool(query: $query) {
      count
      items {
        ...DentalSchoolFields
      }
    }
  }
`

export const CREATE_DENTAL_SCHOOL = gql`
  mutation createDentalSchool($createDentalSchoolInput: CreateDentalSchoolInput!) {
    createDentalSchool(createDentalSchoolInput: $createDentalSchoolInput) {
      id
      title
      description
    }
  }
`

export const FIND_ONE_DENTAL_SCHOOL = gql`
  ${DENTAL_SCHOOL_FIELDS}
  query findOneDentalSchool($id: String!) {
    findOneDentalSchool(id: $id) {
      ...DentalSchoolFields
    }
  }
`

export const UPDATE_DENTAL_SCHOOL = gql`
  ${DENTAL_SCHOOL_FIELDS}
  mutation updateDentalSchool($updateDentalSchoolInput: UpdateDentalSchoolInput!) {
    updateDentalSchool(updateDentalSchoolInputFieldName: $updateDentalSchoolInput) {
      ...DentalSchoolFields
    }
  }
`

export const REMOVE_DENTAL_SCHOOL = gql`
  mutation removeDentalSchool($removeDentalSchoolId: String!) {
    removeDentalSchool(id: $removeDentalSchoolId) {
      raw
      affected
    }
  }
`

// DENTAL SCHOOL LOCATION

const DENTAL_SCHOOL_LOCATION_FIELDS = gql`
  ${DENTAL_SCHOOL_FIELDS}
  fragment DentalSchoolLocationFields on DentalSchoolLocationType {
    id
    title
    description
    schoolLocationType
    isOptometry
    platform {
      id
      title
    }
    dentalSchool {
      ...DentalSchoolFields
    }
    dentalSchoolIds
  }
`

export const FIND_ALL_DENTAL_SCHOOL_LOCATIONS = gql`
  ${DENTAL_SCHOOL_LOCATION_FIELDS}
  query findAllDentalSchoolLocations($query: DentalSchoolLocationQueryInput!) {
    findAllDentalSchoolLocation(query: $query) {
      count
      items {
        ...DentalSchoolLocationFields
      }
    }
  }
`

export const FIND_ONE_DENTAL_SCHOOL_LOCATION = gql`
  ${DENTAL_SCHOOL_LOCATION_FIELDS}
  query findOneDentalSchoolLocation($id: String!) {
    findOneDentalSchoolLocation(id: $id) {
      ...DentalSchoolLocationFields
    }
  }
`

export const CREATE_DENTAL_SCHOOL_LOCATION = gql`
  mutation createDentalSchoolLocation($createDentalSchoolLocationInput: CreateDentalSchoolLocationInput!) {
    createDentalSchoolLocation(createDentalSchoolLocationInput: $createDentalSchoolLocationInput) {
      id
      title
      description
      schoolLocationType
      dentalSchoolIds
    }
  }
`

export const UPDATE_DENTAL_SCHOOL_LOCATION = gql`
  mutation updateDentalSchoolLocation($updateDentalSchoolLocationInput: UpdateDentalSchoolLocationInput!) {
    updateDentalSchoolLocation(updateDentalSchoolLocationInputFieldName: $updateDentalSchoolLocationInput) {
      id
      title
      description
      schoolLocationType
      dentalSchoolIds
    }
  }
`
